import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge, validators } from 'tailwind-merge';

const twMerge = extendTailwindMerge<'raised' | 'raised-size' | 'raised-color'>({
  extend: {
    classGroups: {
      raised: ['raised'],
      'raised-size': [
        { raised: [validators.isNumber, validators.isArbitraryLength] },
      ],
      'raised-color': [{ raised: [validators.isAny] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
